import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter, matchPath } from 'react-router';

import Navigation from '@artsman/react-nav';

var NavigationRouter = function (_PureComponent) {
  _inherits(NavigationRouter, _PureComponent);

  function NavigationRouter(props) {
    _classCallCheck(this, NavigationRouter);

    var _this = _possibleConstructorReturn(this, (NavigationRouter.__proto__ || Object.getPrototypeOf(NavigationRouter)).call(this, props));

    _this.onBrandItemClick = function (item, contentRef) {
      _this.onAnyItemClick(item, contentRef, _this.props.onBrandItemLinkClick);
    };

    _this.onItemClick = function (item, contentRef) {
      _this.onAnyItemClick(item, contentRef, _this.props.onItemLinkClick);
    };

    _this.isBrandItemActive = function (item) {
      return false;
    };

    _this.isItemActive = function (item) {
      return item.active === true || item.active !== false && item.path !== void 0 && matchPath(_this.props.location.pathname, item) !== null;
    };

    _this.formatItemPath = function (path) {
      return path;
    };

    return _this;
  }

  _createClass(NavigationRouter, [{
    key: 'onAnyItemClick',
    value: function onAnyItemClick(item, contentRef, onLinkClick) {
      var path = item.path,
          onClick = item.onClick;

      var prevented = false;
      if (onLinkClick) {
        prevented = onLinkClick(path) === false;
      }
      if (!prevented) {
        var history = this.props.history;

        history.push(path);
      }
      if (onClick) {
        onClick(item, contentRef);
      }
    } // TODO decide if this should be changed

  }, {
    key: 'getFirstActiveGroup',
    // TODO - for hash history etc this will be needed but does nothing for now

    value: function getFirstActiveGroup(path) {
      var firstActiveGroup = null;

      for (var _len = arguments.length, typeItems = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        typeItems[_key - 1] = arguments[_key];
      }

      typeItems.some(function (items) {
        return items && items.some(function (_ref) {
          var id = _ref.id,
              children = _ref.items;
          return children && children.some(function (item) {
            if (item.path !== void 0 && matchPath(path, _extends({}, item, { exact: true })) !== null) {
              firstActiveGroup = id;
              return true;
            }
          });
        });
      });
      return firstActiveGroup;
    }
  }, {
    key: 'getActiveGroupIds',
    value: function getActiveGroupIds() {
      var _primaryLeftItems = this._primaryLeftItems,
          _primaryRightItems = this._primaryRightItems,
          _secondaryItems = this._secondaryItems,
          _pathname = this._pathname;
      var _activePrimaryGroupId = this._activePrimaryGroupId,
          _activeSecondaryGroupId = this._activeSecondaryGroupId;
      var _props = this.props,
          primaryLeftItems = _props.primaryLeftItems,
          primaryRightItems = _props.primaryRightItems,
          secondaryItems = _props.secondaryItems,
          pathname = _props.location.pathname;

      if (_activePrimaryGroupId === void 0 || pathname !== _pathname || primaryLeftItems !== _primaryLeftItems || primaryRightItems !== _primaryRightItems) {
        _activePrimaryGroupId = this._activePrimaryGroupId = this.getFirstActiveGroup(pathname, primaryLeftItems, primaryRightItems);
      }
      if (_activeSecondaryGroupId === void 0 || pathname !== _pathname || secondaryItems !== _secondaryItems) {
        _activeSecondaryGroupId = this._activeSecondaryGroupId = this.getFirstActiveGroup(pathname, secondaryItems);
      }
      this._primaryLeftItems = primaryLeftItems;
      this._primaryRightItems = primaryRightItems;
      this._secondaryItems = secondaryItems;
      this._pathname = pathname;
      return {
        activePrimaryGroupId: _activePrimaryGroupId,
        activeSecondaryGroupId: _activeSecondaryGroupId
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          pathname = _props2.location.pathname,
          otherProps = _objectWithoutProperties(_props2, ['location']);

      var navProps = _extends({}, otherProps, {
        path: pathname
      }, this.getActiveGroupIds(), {
        onBrandItemClick: this.onBrandItemClick,
        onItemClick: this.onItemClick,
        isBrandItemActive: this.isBrandItemActive,
        isItemActive: this.isItemActive,
        formatItemPath: this.formatItemPath
      });

      return React.createElement(Navigation, navProps);
    }
  }]);

  return NavigationRouter;
}(PureComponent);

NavigationRouter.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  onBrandItemLinkClick: PropTypes.func,
  onItemLinkClick: PropTypes.func
};


export default withRouter(NavigationRouter);